module.exports = __webpack_public_path__ + "static/img/RCB24V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RCB24V_1.png
// module id = uhq9
// module chunks = 0